export const translations = {
  en: {
    title: 'GeekLink Generator',
    affiliateId: 'GeekBuying Affiliate ID',
    affiliateIdPlaceholder: 'Enter your affiliate ID',
    url: 'GeekBuying URL',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Generate Link',
    footerText: 'Made with ❤️ by Ayrox',
    fillAllFields: 'Please fill in all fields',
    errorGenerating: "Error generating link",
    generatedLink: "Generated link",
    copy: "Copy",
    copied: "Link copied!",
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  },
  fr: {
    title: 'GeekLink Generator',
    affiliateId: "ID d'affiliation GeekBuying",
    affiliateIdPlaceholder: "Entrez votre ID d'affiliation",
    url: 'URL GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Générer le lien',
    footerText: 'Fait avec ❤️ par Ayrox',
    fillAllFields: 'Veuillez remplir tous les champs',
    errorGenerating: "Erreur lors de la génération du lien",
    generatedLink: "Lien généré",
    copy: "Copier",
    copied: "Lien copié !",
    shortLink: 'Lien raccourci',
    shortening: 'Raccourcissement en cours...',
    errorShortening: 'Erreur lors du raccourcissement du lien',
    mainTitle: 'Générateur de Liens GeekBuying',
    subtitle: 'Créez facilement vos liens d\'affiliation GeekBuying et partagez-les en toute simplicité. Un outil gratuit pour tous les affiliés GeekBuying.'
  },
  de: {
    title: 'GeekLink Generator',
    affiliateId: 'GeekBuying Partner-ID',
    affiliateIdPlaceholder: 'Geben Sie Ihre Partner-ID ein',
    url: 'GeekBuying URL',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Link generieren',
    footerText: 'Gemacht mit ❤️ von Ayrox',
    fillAllFields: 'Bitte füllen Sie alle Felder aus',
    errorGenerating: 'Fehler beim Generieren des Links',
    generatedLink: 'Generierter Link',
    copy: 'Kopieren',
    copied: 'Link kopiert!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'GeekBuying Link-Generator',
    subtitle: 'Erstellen Sie ganz einfach Ihre GeekBuying-Affiliate-Links und teilen Sie sie mühelos. Ein kostenloses Tool für alle GeekBuying-Partner.'
  },
  es: {
    title: 'GeekLink Generator',
    affiliateId: 'ID de afiliado GeekBuying',
    affiliateIdPlaceholder: 'Ingrese su ID de afiliado',
    url: 'URL de GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Generar enlace',
    footerText: 'Hecho con ❤️ por Ayrox',
    fillAllFields: 'Por favor complete todos los campos',
    errorGenerating: 'Error al generar el enlace',
    generatedLink: 'Enlace generado',
    copy: 'Copiar',
    copied: '¡Enlace copiado!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'Generador de Enlaces GeekBuying',
    subtitle: 'Cree fácilmente sus enlaces de afiliados de GeekBuying y compártalos sin esfuerzo. Una herramienta gratuita para todos los afiliados de GeekBuying.'
  },
  it: {
    title: 'GeekLink Generator',
    affiliateId: 'ID affiliato GeekBuying',
    affiliateIdPlaceholder: 'Inserisci il tuo ID affiliato',
    url: 'URL GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Genera link',
    footerText: 'Fatto con ❤️ da Ayrox',
    fillAllFields: 'Si prega di compilare tutti i campi',
    errorGenerating: 'Errore durante la generazione del link',
    generatedLink: 'Link generato',
    copy: 'Copia',
    copied: 'Link copiato!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  },
  pt: {
    title: 'GeekLink Generator',
    affiliateId: 'ID de afiliado GeekBuying',
    affiliateIdPlaceholder: 'Digite seu ID de afiliado',
    url: 'URL GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Gerar link',
    footerText: 'Feito com ❤️ por Ayrox',
    fillAllFields: 'Por favor, preencha todos os campos',
    errorGenerating: 'Erro ao gerar o link',
    generatedLink: 'Link gerado',
    copy: 'Copiar',
    copied: 'Link copiado!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  },
  nl: {
    title: 'GeekLink Generator',
    affiliateId: 'GeekBuying Partner-ID',
    affiliateIdPlaceholder: 'Voer uw partner-ID in',
    url: 'GeekBuying URL',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Link genereren',
    footerText: 'Gemaakt met ❤️ door Ayrox',
    fillAllFields: 'Vul alle velden in',
    errorGenerating: 'Fout bij het genereren van de link',
    generatedLink: 'Gegenereerde link',
    copy: 'Kopiëren',
    copied: 'Link gekopieerd!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Fout bij het raccourcir de link',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  },
  pl: {
    title: 'GeekLink Generator',
    affiliateId: 'ID partnera GeekBuying',
    affiliateIdPlaceholder: 'Wprowadź swoje ID partnera',
    url: 'URL GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Wygeneruj link',
    footerText: 'Wykonane z ❤️ przez Ayrox',
    fillAllFields: 'Proszę wypełnić wszystkie pola',
    errorGenerating: 'Błąd podczas generowania linku',
    generatedLink: 'Wygenerowany link',
    copy: 'Kopiuj',
    copied: 'Link skopiowany!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Error shortening link',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  },
  ru: {
    title: 'GeekLink Generator',
    affiliateId: 'ID партнера GeekBuying',
    affiliateIdPlaceholder: 'Введите ваш ID партнера',
    url: 'URL GeekBuying',
    urlPlaceholder: 'https://www.geekbuying.com/item/...',
    generate: 'Создать ссылку',
    footerText: 'Сделано с ❤️ Ayrox',
    fillAllFields: 'Пожалуйста, заполните все поля',
    errorGenerating: 'Ошибка при создании ссылки',
    generatedLink: 'Созданная ссылка',
    copy: 'Копировать',
    copied: 'Ссылка скопирована!',
    shortLink: 'Short link',
    shortening: 'Shortening...',
    errorShortening: 'Ошибка при сокращении ссылки',
    mainTitle: 'GeekBuying Link Generator',
    subtitle: 'Easily create your GeekBuying affiliate links and share them effortlessly. A free tool for all GeekBuying affiliates.'
  }
}

export type Language = keyof typeof translations 